import { render, staticRenderFns } from "./ApproveLeaveModal.vue?vue&type=template&id=50c62c01&"
import script from "./ApproveLeaveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveLeaveModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveLeaveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports